export enum ERFilterKey {
  DATE = 'date_filter',
  DEVICE = 'device_filter',
  TRAFFIC_SOURCE = 'traffic_source_filter',
  VISITOR = 'visitor_filter',
  EXPERIMENT = 'experiment_filter',
  PAGE = 'page_filter',
  VERSION = 'version_filter',
}
